import CardStatus from "../../../components/card-status";
import Loading from "../../../components/loading";

export default function ListPlanning({
                                       event,
                                       listPlanning,
                                       updatePlanning,
                                       openCardId,
                                       setOpenCardId,
                                       handleRemovedUserFromPlanning,
                                       loadMore,
                                     }) {
  const getDisplayKey = (item) => (item.postCreditId && item.isPostCredit) ? `${item.id}${item.postCreditId}` : `${item.id}`;

  return !!listPlanning.results.length ? (
    <>
      {
        listPlanning.loading ? (
          <div className="wrapper-loading-small">
            <Loading small />
          </div>
        ) : null
      }
      {
        listPlanning?.results.map((item) => {
          const displayKey = getDisplayKey(item);

          return (
            <CardStatus
              key={displayKey}
              data={item}
              isFinished={item.isFinished}
              isConsulting={true}
              showDuplicate={false}
              event={event}
              clickOptions={() => setOpenCardId((prev) =>
                prev === displayKey ? null : displayKey
              )}
              isOpen={openCardId === displayKey}
              onUserRemoved={handleRemovedUserFromPlanning}
              hideLoading={updatePlanning}
              isMonitoring={(item.isPostCredit && !!item.postCreditId)}
            />
          );
        })
      }
      {
        !!listPlanning?.next ? (
          <div className="more-planning">
            <button
              type="button"
              onClick={loadMore}
            >
              Carregar mais planejamentos
            </button>
          </div>
        ) : ''
      }
    </>
  ) : (
    <div className="empty">Nenhum resultado encontrado</div>
  )
}